import PropTypes from 'prop-types';

import CrossFatSVG from '@web-packages/svgs/CrossFat';
import InfoSVG from '@web-packages/svgs/Info';
import ExclamationSVG from '@web-packages/svgs/Exclamation';

import RichText from '../../../Atoms/RichText';
import IconButton, { variants as iconButtonVariants, types as iconButtonTypes } from '../../../Inputs/IconButton';

import { Wrapper, InfoText } from './styled';
import types from './types';
import variants from './variants';

const iconTypes = {};
iconTypes[types.infoMessage] = InfoSVG;
iconTypes[types.warningMessage] = ExclamationSVG;
const getIconBasedOnType = (type) => (iconTypes[type]);

const AnnouncementModal = ({
  variant,
  type,

  showModal,
  setShowModal,

  richText,
}) => {
  if (!showModal) return null;

  const announcementIconSVG = getIconBasedOnType(type);
  return (
    <Wrapper
      variant={variant}
      type={type}
    >
      <IconButton
        className="announcement-type-icon"
        type={iconButtonTypes.large}
        variant={iconButtonVariants.white}
        icon={announcementIconSVG}
        onClick={() => null}
      />

      <InfoText>
        <RichText
          html={richText}
        />
      </InfoText>

      <IconButton
        className="close-announcement-icon"
        type={iconButtonTypes.standard}
        variant={iconButtonVariants.white}
        icon={CrossFatSVG}
        onClick={() => setShowModal(false)}
      />
    </Wrapper>
  );
};

AnnouncementModal.propTypes = {
  type: PropTypes.oneOf(Object.values(types)).isRequired,
  variant: PropTypes.string,

  showModal: PropTypes.bool,
  setShowModal: PropTypes.func.isRequired,

  richText: PropTypes.string.isRequired,
};
AnnouncementModal.defaultProps = {
  variant: variants.primary,
  showModal: false,
};

export default AnnouncementModal;
